export { SEARCH_SPOTLIGHT_KEY, NavigationSearchDialog } from '../src/NavigationSearchDialog.tsx';
